import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { BotCfElementSequenceContainerModel } from "../../../../../../models/aggregates/alg/bot";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";

@Injectable({providedIn: "root"})
export class BotCfElementSequenceService extends BaseApiTemplateService<BotCfElementSequenceContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'bot-cf-element-sequence';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'bot-cf-element-sequence';
    this.httpClient = http;
  }

  search(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<BotCfElementSequenceContainerModel>> {
    let url = this.apiUrl + '/search';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/search' + '?' + pagination.getQueryKeyValues();;
    }
    return this.httpClient.get<PagingResponseModel<BotCfElementSequenceContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getAvailableNextElementsGuids(conversation_flow_guid: string, current_element_guid: string, visa: ApiVisa): Observable<ApiResponseModel<string[]>> {
    let url = this.apiUrl + '/availableNextElementsGuids';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/availableNextElementsGuids' + '?';
    }

    const params = new HttpParams()
    .set('conversation_flow_guid', conversation_flow_guid)
    .set('current_element_guid', current_element_guid);

    return this.httpClient.get<ApiResponseModel<string[]>>(
      url,
      {
        ...this.getHttpHeader(visa),
        params
      }
    );
  }

}
